<template>
    <div class="pexel-images">
        <div class="pexel-images__grid">
            <div
                v-for="(image, index) in displayImages"
                :key="index"
                class="pexel-images__item"
            >
                <a
                    v-if="consentStore.externalAllowed"
                    :href="image.authorUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    :title="`Photo by ${image.authorName} on Pexels`"
                >
                    <ExternalImage
                        :src="image.src"
                        :alt="`Travel photo by ${image.authorName}`"
                        class="pexel-images__img"
                        @error="onImageError(index)"
                    />
                    <div class="pexel-images__overlay">
                        <span class="pexel-images__author">
                            <span class="material-symbols-outlined"
                                >person</span
                            >
                            {{ image.authorName }}
                        </span>
                    </div>
                </a>
                <ExternalImage
                    v-else
                    :src="image.src"
                    class="pexel-images__img"
                />
            </div>
        </div>
        <p class="pexel-images__attribution">
            Photos provided by
            <a
                href="https://www.pexels.com"
                target="_blank"
                rel="noopener noreferrer"
                >Pexels</a
            >
        </p>
    </div>
</template>

<script>
import { cropUrl } from "js/lib/pexels";
import { useConsentStore } from "js/stores/consentStore.js";
import ExternalImage from "js/components/common/ExternalImage.vue";

const NARROW_VIEWPORT_QUERY = "(max-width: 600px)";

export default {
    name: "PexelImages",
    components: {
        ExternalImage,
    },
    props: {
        images: {
            type: Array,
            default: () => [],
        },
        max: {
            type: Number,
            default: 4,
        },
    },
    data() {
        return {
            broken: {},
            isNarrow: false,
            mediaQuery: null,
            consentStore: useConsentStore(),
        };
    },
    computed: {
        displayImages() {
            return this.images
                .filter((val, index) => {
                    return !this.broken[index];
                })
                .slice(0, this.max)
                .map((image) => ({
                    src: this.isNarrow ? this.portraitUrl(image) : image[2],
                    authorName: image[3],
                    authorUrl: image[4],
                }));
        },
    },
    mounted() {
        this.mediaQuery = window.matchMedia(NARROW_VIEWPORT_QUERY);
        this.isNarrow = this.mediaQuery.matches;
        this.mediaQuery.addEventListener("change", this.onViewportChange);
    },
    beforeUnmount() {
        this.mediaQuery?.removeEventListener("change", this.onViewportChange);
    },
    methods: {
        onViewportChange(e) {
            this.isNarrow = e.matches;
        },
        portraitUrl(image) {
            return image[5] ?? cropUrl(image[0], 800, 1200);
        },
        onImageError(index) {
            this.broken[index] = true;
        },
    },
};
</script>
